export const PAYMENT_GATEWAY_SETTINGS_LOAD_SUCCESS = "PAYMENT_GATEWAY_SETTINGS_LOAD_SUCCESS";
export const PAYMENT_SIGNATURE_LOAD_SUCCESS = " PAYMENT_SIGNATURE_LOAD_SUCCESS";
export const PAYMENT_GATEWAY_SETTINGS_LOAD_FAIL = "PAYMENT_GATEWAY_SETTINGS_LOAD_FAIL";
export const PAYMENT_SIGNATURE_LOAD_FAIL = " PAYMENT_SIGNATURE_LOAD_FAIL";
